export default function runWithTimeout<T>(
    callback: (resolve: (value: T) => void) => void | Promise<void>,
    cleanUp: () => void,
    timeout: number
): Promise<T> {
    return new Promise<T>(resolve => {
        let timerId: number;

        function finish(value: T) {
            timerId = 0;
            cleanUp();
            resolve(value);
        }

        timerId = window.setTimeout(() => {
            finish(null);
        }, timeout);

        const wrappedResolve = (value: T) => {
            if (timerId) {
                window.clearTimeout(timerId);
                finish(value);
            }
        };
        callback(wrappedResolve);
    });
}
